import PropTypes from "prop-types";
import React, { useState } from 'react';
import { useRef } from "react";
import { Col, Card, Modal, Button } from 'react-bootstrap';
import { Edit, Trash2 } from 'lucide-react';
import { useDeleteImageMutation, useEditImageMutation } from "../../app/api";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

export default function ImageCard({ image , rerun }){
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteImage] = useDeleteImageMutation();
  const [editImage] = useEditImageMutation();

  const titleRef = useRef();
  const categoryRef = useRef();

  const handleEdit = async (image_id) => {
    await editImage({image_id: image_id, title: titleRef.current.value, category: categoryRef.current.value})
    setShowEditModal(false);
    rerun();
  };

  const handleDelete = async (image_id) => {
    await deleteImage({image_id: image_id})
    setShowDeleteModal(false);
    rerun();
  };

  const editPopUp = 
      <>
        <FloatingLabel controlId='floatingInput' label='Title' className='mb-3'>
          <Form.Control
            type="text"
            defaultValue={image.title}
            ref = {titleRef}
          />
        </FloatingLabel>
        <FloatingLabel controlId='floatingInput' label='Description' className='mb-3'>
          <Form.Control
            type="text"
            defaultValue={image.category}
            ref = {categoryRef}
          />
        </FloatingLabel>
      </>

  return (
    <Col md={6} lg={3} className="mb-4">
      <div className="position-relative">
        <div className="position-absolute top-0 end-0 m-2 d-flex gap-2" style={{ zIndex: 10 }}>
          <button 
            onClick={() => setShowEditModal(true)}
            className="btn btn-dark btn-sm p-1"
            style={{ background: 'rgba(33, 37, 41, 0.7)' }}
          >
            <Edit className="text-white" size={16} />
          </button>
          <button 
            onClick={() => setShowDeleteModal(true)}
            className="btn btn-danger btn-sm p-1"
            style={{ background: 'rgba(220, 53, 69, 0.7)' }}
          >
            <Trash2 className="text-white" size={16} />
          </button>
        </div>
        
        <Card className="h-100 bg-dark text-white border-secondary">
          <Card.Img 
            variant="top" 
            src={`https://ffn-email-design.s3.us-west-2.amazonaws.com/${image.filename}`}
            style={{ height: '200px', objectFit: 'cover' }}
          />
          <Card.Body>
            <Card.Title>{image.title}</Card.Title>
            <p>{image.category}</p>
          </Card.Body>
        </Card>

        {/* Edit Confirmation Modal */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editPopUp}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => {handleEdit(image.id)}}>
              Save 
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Image</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete &quot;{image.title}&quot;? This action cannot be undone.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={() => {handleDelete(image.id)}}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Col>
  );
};

ImageCard.propTypes = {
  image: PropTypes.object,
  rerun: PropTypes.func,
}